'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function Controller($filter, $scope, $state, AppConstants, PageHeading, DiscountComponent, Toast) {
	'ngInject';

	var vm = this;
	vm.createDiscount = createDiscount;
	vm.discount = { 'translations': [] };
	vm.languages = AppConstants.languages;

	activate();

	function activate() {
		var heading = $filter('translate')('HEADING.CREATING_NEW_DISCOUNT');
		var title = 'BTMS | ' + $filter('translate')('TITLE.NEW_DISCOUNT');

		PageHeading.setPageHeading(heading, title);

		vm.languages.forEach(function (lang) {
			return vm.discount.translations.push({ 'lang': lang, 'name': '' });
		});
	}

	function createDiscount(params) {
		var form = $scope.createDiscount;
		var nameLengthInvalid = false;

		for (var i = 0; i < vm.languages.length; i++) {
			if (form['discountDescription-' + i].$error.minlength || form['discountDescription-' + i].$error.maxlength) {
				nameLengthInvalid = true;
				break;
			}
		}

		if (form.$error.required || form.value.$error.min || !vm.discount.type || nameLengthInvalid) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		DiscountComponent.createDiscount(params).then(function (res) {
			if (res.data.errors) {
				Toast.responseError(res.data.errors);
			} else {
				Toast.success($filter('translate')('SUCCESS.CREATE_DISCOUNT'));
				$state.go('app.private.discounts.list');
			}
		});
	}
}

exports['default'] = Controller;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/discounts/create/create.controller.js
 **/